import {Injectable} from '@angular/core';
import {HttpClient, HttpHandler} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {File} from '../../interfaces/File/File';

@Injectable()
export class FileApiClass extends HttpClient {
  private baseUrl = environment.production ? '/channel-virtual/api/v1' + '/file' : environment.baseUrl + '/file';


  constructor(handler: HttpHandler) {
    super(handler);
  }

  public writeFile(file): Observable<any> {
    const url = `${this.baseUrl}/write`;
    return super.post(url, file);

  }

}
